// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonWithProgress_wrapper__v1KGQ","loading":"ButtonWithProgress_loading__nzdUB","buttonProgress":"ButtonWithProgress_buttonProgress__kTGZp"};